<template>
    <div>
        <b-form @submit="onSubmit" class="custom-margin"> 
        <b-row class="custom-margin">
            <b-col cols="12"> 
                <div class="pull-right">
                    <b-button v-if="isFromMessage" v-b-modal.modalReactie variant="themecolor" size="m"><i class="fa fa-comment" aria-hidden="true"></i></b-button>
                </div>     
                    <b-button @click="goToHome()" variant="transparent" size="sm" class="pull-left">
                        <font-awesome-icon icon="angle-left" size="2x" />
                    </b-button>
                    <h3 class="text-themecolor my-1">Trigger {{!this.isNewTrigger  ?  "Bewerken" : "Aanmaken"}}</h3>
         
            </b-col>
        </b-row>
        <b-row class="custom-margin">
            <b-col v-if="command.triggerId !== undefined && command.triggerId !== ''" md="4" class="nopadding">         
                 
                <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7"  label="Naam" label-for="input-horizontal">
                    <b-form-input ref="name" :key="readCommand.factuurdatum" id="input-horizontal" v-model="command.naam"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldset-horizontal" label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7" label="Fablet" label-for="input-horizontal">
                    <MatchRegex ref="fablet" :key="readCommand.keywords" :regex="command.fablet" :testcontent="combinedTestContent" @changeIt="onFabletChanged($event)" @onChange='command["fablet"]=$event; getFabletResult($event, document.filecontent)' :isForFablet="true" style="margin-left: 0px" />
                </b-form-group>   
                <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7">
                    <!--When more Modifiers change above to '<b-form-group label="Modifers">' and remove the label class 'pull-left'-->
                   <b-form-checkbox id="checkbox-1" name="checkbox-1" class="pull-left">Credit</b-form-checkbox>
                </b-form-group> 

                <br/>
                <h2>Kopgegevens</h2>
                
                <b-form-group label="Factuurnummer" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                    <MatchRegex ref="factuurnummer" :key="readCommand.factuurnummer" :testcontent="combinedTestContent" :regex="command.factuurnummer" @onChange='command["factuurnummer"]=$event' @resultRegex='onHandleRegexResult($event,"factuurnummer")'  class="no-margin-left" :dropdown=true :options="options.factuurnummer" :tryMatchFirstOption=watchOptionsFactuurnummer :regexFieldType="regexFieldTypeEnum.Numberic" />
                </b-form-group>
                <b-form-group label="Factuurdatum" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                    <MatchRegex ref="factuurdatum" :key="readCommand.factuurdatum" :testcontent="combinedTestContent" :regex="command.factuurdatum" @onChange='command["factuurdatum"]=$event' @resultRegex='onHandleRegexResult($event,"factuurdatum")' class="no-margin-left" :dropdown=true :options="options.factuurdatum" :tryMatchFirstOption=watchOptionsFactuurdatum :regexFieldType="regexFieldTypeEnum.Date" />
                </b-form-group>

                <b-form-group label="Referentie" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                    <MatchRegex ref="referentie" :key="readCommand.referentie" :testcontent="combinedTestContent" :regex="command.referentie" :showRegexField=false @onChange='command["referentie"]=$event' @resultRegex='onHandleRegexResult($event,"referentie")' class="no-margin-left" />
                </b-form-group>

                <br/>
                <h2>Bedragen</h2>

                <b-form-group label="Totaalbedrag" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                    <MatchRegex ref="totaalbedrag" :key="readCommand.totaalbedrag" :testcontent="combinedTestContent" :regex="command.totaalbedrag" @onChange='command["totaalbedrag"]=$event' @resultRegex='onHandleRegexResult($event,"totaalbedrag")' class="no-margin-left" :dropdown=true :options="options.totaalbedrag" :tryMatchFirstOption=watchOptionsTotaalbedrag />
                </b-form-group>
                <b-form-group label="Subtotaal" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                    <MatchRegex ref="subtotaal" :key="readCommand.subtotaal" :testcontent="combinedTestContent" :regex="command.subtotaal" @onChange='command["subtotaal"]=$event' @resultRegex='onHandleRegexResult($event,"subtotaal")' class="no-margin-left" :dropdown=true :options="options.subtotaal" :tryMatchFirstOption=watchOptionsSubtotaal />
                </b-form-group>

                <b-form-group label="BTW laag" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                    <MatchRegex ref="btwLaag" :key="readCommand.btwLaag" :testcontent="combinedTestContent" :regex="command.btwLaag" @onChange='setBtwLaag($event)' :dropdown=true :options="options.btwLaag" @resultRegex='onHandleRegexResult($event,"btwLaag")' class="no-margin-left" />
                </b-form-group>
                <b-form-group label="BTW hoog" label-for="input-formatter" class="mb-0" label-class="mb-0">
                    <MatchRegex ref="btwHoog" :key="readCommand.btwHoog" :testcontent="combinedTestContent" :regex="command.btwHoog" @onChange='setBtwHoog($event)' :dropdown=true :options="options.btwHoog" @resultRegex='onHandleRegexResult($event,"btwHoog")' class="no-margin-left" />
                </b-form-group>

                <b-form-group label="Kosten nul" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                    <MatchRegex ref="kostenNul" :key="readCommand.kostenNul" :testcontent="combinedTestContent" :regex="command.kostenNul" @onChange='command["kostenNul"]=$event' :dropdown=true :options="options.kostenNul" @resultRegex='onHandleRegexResult($event,"kostenNul")' class="no-margin-left" />
                </b-form-group>

                <b-form-group label="Kosten verlegd" label-for="input-formatter" class="mb-0" label-class="mb-0" >
                    <MatchRegex ref="kostenVerlegd" :key="readCommand.kostenVerlegd" :testcontent="combinedTestContent" :regex="command.kostenVerlegd" @onChange='command["kostenVerlegd"]=$event' @resultRegex='onHandleRegexResult($event,"kostenVerlegd")' :dropdown=true :options="options.kostenVerlegd" class="no-margin-left" />
                </b-form-group>

                <b-form-group v-if="renderKostenLaag" label="Kosten laag" label-for="input-formatter" class="mb-0" label-class="mb-0">
                    <MatchRegex  ref="kostenLaag" :key="readCommand.kostenLaag" :testcontent="combinedTestContent" :regex="command.kostenLaag" @onChange='command["kostenLaag"]=$event' @resultRegex='onHandleRegexResult($event,"kostenLaag")' :dropdown=true :options="options.kostenLaag" class="no-margin-left" />
                </b-form-group>

                <b-form-group v-if="renderKostenHoog" label="Kosten hoog" label-for="input-formatter" class="mb-0" label-class="mb-0">
                    <MatchRegex ref="kostenHoog" :key="readCommand.kostenHoog" :testcontent="combinedTestContent" :regex="command.kostenHoog" @onChange='command["kostenHoog"]=$event' @resultRegex='onHandleRegexResult($event,"kostenHoog")' :dropdown=true :options="options.kostenHoog" class="no-margin-left" />
                </b-form-group>
                
                <br/>
                <b-button id="btn-save-trigger" size="sm" type="submit"  variant="themecolor" :disabled="disableButton">{{!this.isNewTrigger  ?  (document.isEdited == '1' ? "Trigger toepassen" : "Trigger toepassen en opnieuw door ocr") : "Trigger aanmaken"}}</b-button>                
           </b-col>
            <b-col md="4" class="my-1 nopadding" >
                <div class="content-box">
                    <div class="content-title">OCR content</div>
                    <text-highlight :queries="regexResult" class="textarea-text">
                        {{ document.filecontent }}
                    </text-highlight>
                </div>

                <div class="content-box mt-3">
                    <div class="content-title">PDF content</div>
                    <text-highlight :queries="regexResult" class="textarea-text">
                        {{ document.pdfcontent }}
                    </text-highlight>
                </div>
            </b-col>
            <b-col md="4" class="my-1 nopadding" >            
                    <div v-if="!isImageLoaded">
                        <PreLoader/>
                    </div>
                    <b-card-text v-if="isImageLoaded"> <v-zoomer><img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100" /></v-zoomer></b-card-text>        
            </b-col>
        </b-row>
        </b-form>
        <b-modal id="modalReactie" ref="priceagreements" :title="`Melding`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
            <b-form autocomplete="off">
                <b-textarea id="reactie" :value="melding" type="text" />
            </b-form>
        </b-modal>

    </div>
</template>
<script>
import MatchRegex from '@/components/fmmanagement/MatchRegex.vue'
import { mapGetters, mapActions } from 'vuex'
import Command from './command'
import PreLoader from '@/components/root/Preloader';
import TextHighlight from 'vue-text-highlight';
import { fabletMixin } from '@/mixins/fabletMixin';
import RegexFieldTypeEnum from "@/enums/modules/RegexFieldType";

export default {
    name: 'document-trigger',
    components: {MatchRegex,PreLoader, TextHighlight},
    props: [ 'isFromMessage', 'melding' ],
    mixins: [fabletMixin],
    data() {
        return {
            readCommand: new Command(),
            command: new Command(),
            renderKostenLaag: true,
            renderKostenHoog: true,
            image: '',
            isImageLoaded: false,
            isNewTrigger: false,
            options: { factuurnummer: [], factuurdatum: [], totaalbedrag: [], subtotaal: [], btwLaag: [], btwHoog: [], kostenNul: [], kostenVerlegd: [], kostenLaag: [], kostenHoog:[]},
            disableButton: false,
            componentKeyFactuurnummer: '',
            componentKeyFactuurdatum: '',
            componentKeyTotaalbedrag: '',
            componentKeySubtotaal: '',
            regexResult: '',
            isEditingFablet: false,
            watchOptionsFactuurnummer: false,
            watchOptionsFactuurdatum: false,
            watchOptionsTotaalbedrag: false,
            watchOptionsSubtotaal: false,
            regexFieldTypeEnum: RegexFieldTypeEnum
        }
    },
    computed: {
        ...mapGetters('fmmodule',['document','trigger', 'triggers']),
        ...mapGetters('errors', ['statusCode', 'notFoundError']),

        commandProps() {
            return this.command
        },

        combinedTestContent() {
            const document = this.document || {}
            const fileContent = document.filecontent || ''
            const pdfContent = document.pdfcontent || ''

            return fileContent + '\n\n' + pdfContent
        }       
    },
    methods: {
        ...mapActions('fmmodule',['find','update','executeCommand','getImage','execute']),
        goToHome()
        {
            if (this.isFromMessage) {
                 this.$router.push({ name: `triggermeldingen:index`});
            }
            else
            {
                this.$router.push({ name: `documents:detail`, params: { documentId: this.command.id } });   
            }                
        },
        onHandleRegexResult(event, valueName) {
            this.regexResult = event.regexResult;
            this.isEditingFablet = false;

            if (valueName === "btwLaag") {
                this.setBtwLaag(event.regexApplied);
            }
            else if (valueName === "btwHoog") {
                this.setBtwHoog(event.regexApplied);
            }
            else
            {
                this.command[valueName] = event.regexApplied;
            }
        },
        onFabletChanged(isInvalidFablet)
        {
            this.disableButton = isInvalidFablet;
            this.isEditingFablet = true;

        },
        getFabletResult(fablet, content) {
            this.regexResult = fabletMixin.getMusthaveKeywords(fablet, content);
        },
        async setBtwLaag(event) {
            if (this.command["btwLaag"] === event) {
                return
            }

            this.command["btwLaag"] = event

            if (event === "") {
                return
            }
                        
            if (this.command["kostenLaag"] == undefined || this.command["kostenLaag"] == null || this.command["kostenLaag"] === "" )
            {
                this.renderKostenLaag = false

                this.command["kostenLaag"] = this.command["subtotaal"]
                this.readCommand["kostenLaag"] = this.command["subtotaal"]

                await this.$nextTick();
                this.renderKostenLaag = true
            }
        },
        async setBtwHoog(event) {
            if (this.command["btwHoog"] === event) {
                return
            }

            this.command["btwHoog"] = event

            if (event === "") {
                return
            }

            if (this.command["kostenHoog"] == undefined || this.command["kostenHoog"] == null || this.command["kostenHoog"] === "" )
            {
                this.renderKostenHoog = false

                this.command["kostenHoog"] = this.command["subtotaal"]
                this.readCommand["kostenHoog"] = this.command["subtotaal"]

                await this.$nextTick();
                this.renderKostenHoog = true
            }
        },        
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            
            var payload = {
                resource: "documenten",
                id: this.command.id,
                action: "trigger",
                params: vm.command
            };

            vm.command.triggerId = this.$route.params.triggerId 
            vm.command.testcontent = vm.document.filecontent 
            vm.command.testfilename = vm.document.filename

            vm.execute(payload)
                .then(()=> {
                    if (this.isFromMessage) {
                        this.$router.push({ name: `triggermeldingen:index`, params: { triggerId: this.command.triggerId, triggermeldingId: this.$route.params.triggermeldingId }});
                    }
                    else {
                        this.$router.push({ name: `documents:index`});
                    }            
                });
        },
        loadImage()
        {
            var vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.getImage(
                {
                    resource:"images",
                    filename: vm.document.filename
                }
                ).then((response) => {
                    this.isImageLoaded = true
                    this.image = response;
                }  )
        },
        async getDropdownItems(column)
        {
            var vm = this;
            await vm.executeCommand({resource: 'triggers/getTopFive?column=' + column})
                     .then((data) => {                   
                        this.options[column] = data.split("|||")
                        if (this.options[column].length > 0)
                        {
                            if (column === "factuurnummer") this.watchOptionsFactuurnummer = true
                            else if (column === "factuurdatum") this.watchOptionsFactuurdatum = true
                            else if (column === "totaalbedrag") this.watchOptionsTotaalbedrag = true
                            else if (column === "subtotaal") this.watchOptionsSubtotaal = true
                        }
                    }).catch(() => {
                        vm.$swal("Er is iets verkeerd gegaan bij ophalen DropDown items, probeer het opnieuw");
                    });
        }
    },
    async mounted() {      
        var vm = this;
        vm.command.documentId = this.$route.params.documentId
        vm.command.id = this.$route.params.documentId
        this.isNewTrigger = this.$route.params.triggerId == 0;
        if(!this.isNewTrigger)
        {
            vm.find({
                resource: 'triggers',
                id: this.$route.params.triggerId
            })
            .then(() => {
                vm.command.triggerId = vm.trigger.triggerId
                vm.command.naam = vm.trigger.naam
                vm.command.fablet = vm.trigger.keywords
                vm.command.factuurnummer = vm.trigger.factuurnummer
                vm.command.factuurdatum = vm.trigger.factuurdatum
                vm.command.totaalbedrag = vm.trigger.totaalbedrag
                vm.command.subtotaal = vm.trigger.subtotaal
                vm.command.btwLaag = vm.trigger.btwLaag
                vm.command.btwHoog = vm.trigger.btwHoog
                vm.command.btwNul = vm.trigger.btwNul
                vm.command.kostenLaag = vm.trigger.kostenLaag
                vm.command.kostenHoog = vm.trigger.kostenHoog
                vm.command.kostenNul = vm.trigger.kostenNul
                vm.command.kostenVerlegd = vm.trigger.kostenVerlegd

                vm.readCommand = new Command(vm.trigger)
            })
        }
        else
        {                  
            vm.command.triggerId = 0
            vm.command.naam = this.$route.params.triggername
            vm.command.fablet = "+();+()"
        
            vm.command.btwLaag = ""
            vm.command.btwHoog = ""
            vm.command.btwNul = ""
            vm.command.kostenLaag = ""
            vm.command.kostenHoog = ""
            vm.command.kostenNul = ""
            vm.command.kostenVerlegd =""
        }

        this.getDropdownItems('factuurnummer')
        this.getDropdownItems('factuurdatum')
        this.getDropdownItems('totaalbedrag')
        this.getDropdownItems('subtotaal')
        this.getDropdownItems('btwLaag')
        this.getDropdownItems('btwHoog')
        this.getDropdownItems('kostenNul')
        this.getDropdownItems('kostenVerlegd')
        this.getDropdownItems('kostenLaag')
        this.getDropdownItems('kostenHoog')
        
        vm.find({
            resource: 'documenten',
            id: this.$route.params.documentId
        })
        .then(() => {
            this.loadImage();            
        })
    }

}

</script>
<style >
    .custom-margin{
        margin-left: -1.4vw !important;
        margin-right: -1.4vw !important;
    }
    .nopadding {
        padding: 0 !important;
        margin: 0 !important;
    }
    .no-margin-left{
        margin-left: 0px !important
    }
    .textarea-text{
        white-space: pre-line;
    }  

    .content-box {
        border: 1px solid #ced4da;
        border-radius: 6px;
        margin-bottom: 10px;
        margin-right: 10px;
        overflow: hidden;      /* belangrijk i.v.m. afgeronde hoeken */
    }

    .content-title {
        padding: 6px 10px;
        background: #f8f9fa;
        border-bottom: 1px solid #ced4da;
        font-weight: bold;
    }

    .content-box text-highlight {
        display: block;
        padding: 10px;
    }
</style>